const HEADING_SELECTOR = ".prose-block :is(h2,h3,h4,h5,h6)[id]"
const TOUCH_QUERY = "(hover: none), (pointer: coarse)"

const chainIcon = `
  <svg class="heading-anchor__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
    <path d="M10.6 13.4a1 1 0 0 0 1.4 1.4l4.6-4.6a3 3 0 0 0-4.2-4.2l-.9.9a1 1 0 1 0 1.4 1.4l.9-.9a1 1 0 0 1 1.4 1.4l-4.6 4.6Z" />
    <path d="M13.4 10.6a1 1 0 0 0-1.4-1.4l-4.6 4.6a3 3 0 0 0 4.2 4.2l.9-.9a1 1 0 1 0-1.4-1.4l-.9.9a1 1 0 0 1-1.4-1.4l4.6-4.6Z" />
  </svg>
`

const absoluteAnchorUrl = (id) => {
  const url = new URL(window.location.href)
  url.hash = id
  return url.toString()
}

const copyToClipboard = async (url) => {
  if (!navigator.clipboard?.writeText) return false

  try {
    await navigator.clipboard.writeText(url)
    return true
  } catch {
    return false
  }
}

const isPlainPrimaryActivation = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey

const positionStatus = (anchor, status) => {
  const gap = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--space-2")) || 8
  const anchorBox = anchor.getBoundingClientRect()
  const headingBox = anchor.parentElement.getBoundingClientRect()

  status.style.left = `${anchorBox.right - headingBox.left + gap}px`
  status.style.top = `${anchorBox.top - headingBox.top + (anchorBox.height / 2)}px`
}

const showStatus = (anchor, status, text) => {
  window.clearTimeout(anchor.headingAnchorTimer)
  positionStatus(anchor, status)
  anchor.classList.add("is-copied")
  status.classList.add("is-visible")
  status.textContent = text

  anchor.headingAnchorTimer = window.setTimeout(() => {
    anchor.classList.remove("is-copied")
    status.classList.remove("is-visible")
    status.textContent = ""
  }, 1500)
}

const handleHeadingTap = (heading) => {
  if (!window.matchMedia(TOUCH_QUERY).matches) return

  heading.addEventListener("click", (event) => {
    if (event.target.closest("a, button, input, select, textarea")) return

    window.location.hash = heading.id
  })
}

const enhanceHeading = (heading) => {
  if (heading.querySelector(":scope > .heading-anchor")) return

  const anchor = document.createElement("a")
  anchor.className = "heading-anchor"
  anchor.href = `#${encodeURIComponent(heading.id)}`
  anchor.setAttribute("aria-label", "Copy link to this section")
  anchor.innerHTML = chainIcon

  const status = document.createElement("span")
  status.className = "heading-anchor__status"
  status.setAttribute("aria-live", "polite")
  status.setAttribute("aria-atomic", "true")

  anchor.addEventListener("click", async (event) => {
    const url = absoluteAnchorUrl(heading.id)

    if (!window.matchMedia(TOUCH_QUERY).matches && isPlainPrimaryActivation(event)) {
      event.preventDefault()
      history.replaceState(null, "", `#${encodeURIComponent(heading.id)}`)
    }

    const copied = await copyToClipboard(url)
    showStatus(anchor, status, copied ? "Copied" : "Link ready")
  })

  heading.append(anchor)
  heading.append(status)
  handleHeadingTap(heading)
}

const enhanceHeadingAnchors = () => {
  document.querySelectorAll(HEADING_SELECTOR).forEach(enhanceHeading)
}

document.addEventListener("DOMContentLoaded", enhanceHeadingAnchors)
